export default {
  title: "ETS - Environment Total System By Luhott - Portal Acceso Clientes"
};
